export default __webpack_public_path__ + "static/media/thaigot-screenshot-01.9406d037.png";